import { sendAxiosRequest } from '../../utils/sendRequest';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IDataObjectParams from '../../../models/params/IDataObjectParams';
import IMerchProductOrder from '../../../models/restful/IMerchProductOrder';
import IMerchProductOrderResponse from '../../../models/responces/IMerchProductOrderResponse';

export interface IApiCreateOrderParams {
  order?: IMerchProductOrder;
  dataObjectParams?: IDataObjectParams;
}
const apiCreateOrder = (params: IApiCreateOrderParams) =>
  sendAxiosRequest({
    method: 'post',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'order',
      action: 'create',
      dataObjectParams: params.dataObjectParams || undefined
    }),
    data: params.order || {},
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IMerchProductOrderResponse>;
export default apiCreateOrder;
